import { useGetSession } from "@/api/auth/queries";
import { analytics } from "@/lib/segment-analytics";

/*
 * useSegment hook
 * This hook is used to send page and track events to segment
 */
export const useSegment = () => {
  /* Queries */
  const { data: session, isLoading: isSessionLoading, isError: isSessionError } = useGetSession();

  /* Constants */
  const user = session?.user;
  const account = session?.account;

  // default data to send with every event
  const commonData = {
    userId: user?.id,
    accountName: account?.company,
    accountType: account?.type,
    accountTier: account?.tier,
    accountId: account?.id,
    subscriptionId: session?.subscription?.id,
    subscriptionChargebeeId: session?.subscription?.chargebeeId,
    subscriptionStatus: session?.subscription?.status,
    planId: session?.subscription?.plan?.id,
    planChargebeeId: session?.subscription?.plan?.chargebeeId,
    organizationId: account?.organisation ? account.organisation.id : "",
    studioVersion: "3",
    buildVersion: APP_VERSION,
  };

  /* Segment page function */
  const segmentPageEvent = (name: string, segmentData?: Record<string, unknown>) => {
    if (!isSessionLoading && !isSessionError && session) {
      analytics.page(
        name,
        {
          ...segmentData,
          ...commonData,
        },
        {
          groupId: account?.id,
        },
      );
    }
  };

  /* Segment tracking function */
  const segmentTrackEvent = (name: string, segmentData?: Record<string, unknown>) => {
    if (!isSessionLoading && !isSessionError && session) {
      analytics.track(
        name,
        {
          ...segmentData,
          ...commonData,
        },
        {
          groupId: account?.id,
        },
      );
    }
  };

  /* Return */
  return {
    segmentPageEvent,
    segmentTrackEvent,
  };
};
